import WOW from "wow.js";

$(() => {
  // header toggler
  $(".header__nav-toggler").click(function () {
    if (window.innerWidth < 992) {
      $(".header__nav").slideToggle(250);
      $(this).toggleClass("active");

      if ($(this).hasClass("active")) {
        $(".header__nav-toggler use").attr("href", "#icon-cross");
      } else {
        $(".header__nav-toggler use").attr("href", "#icon-menu");
      }
    }
  });

  $(".header__nav-inner-item").click(function () {
    if (window.innerWidth < 992) {
      $(".header__nav-inner-list").slideToggle(250);
      $(this).toggleClass("active");
    }
  });

  // footer notice
  $(".footer__notice-toggler").click(function () {
    $(".footer__notice-list").slideToggle(250);
    $(this).toggleClass("active");

    if (!$(this).hasClass("active")) {
      $(".footer__notice-toggler use").attr("href", "#icon-plus");
    } else {
      $(".footer__notice-toggler use").attr("href", "#icon-minus");
    }
  });

  // cookies alert
  let cookiesIsAgree = localStorage.getItem('cookieConsent');

  if (!cookiesIsAgree) {
    $("#cookies-alert").removeClass("d-none");
  } else {
    $(".back-top-button").removeClass("has-coookies");
  }

  $("#cookies-alert-button").click(function () {
    $("#cookies-alert").hide();
    $(".back-top-button").removeClass("has-cookies");
    localStorage.setItem('cookieConsent', 'true');
  });

  // wowJS
  const wow = new WOW({
    animateClass: "animate__animated",
    live: false,
  });
  wow.init();
});

let windowWidth = window.innerWidth;

$(window).on("resize", function () {
  if (window.innerWidth !== windowWidth) {
    if (window.innerWidth >= 992) {
      $(".header__nav-inner-item").removeClass("active");
      $(".header__nav-inner-list").css("display", "");
    }
  }

  windowWidth = window.innerWidth;
});

$(window).on("load", function () {
  let scrollTimeout;
  // -- back to top button --
  const backTopButton = $(".back-top-button");
  $(window).scroll(function () {
    // 控制顯現與隱藏
    if ($(this).scrollTop() > 20) {
      backTopButton.fadeIn(200);
    } else {
      backTopButton.fadeOut(200);
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      // 控制出現的位置
      if ($(window).scrollTop() + $(window).height() + 2 >= $(document).height()) {
        backTopButton.addClass("upper-position");
      } else {
        backTopButton.removeClass("upper-position");
      }
    }, 200);
  });

  backTopButton.click(function () {
    // For modern browsers (Chrome, Firefox, Safari, Opera)
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // For Internet Explorer
    document.body.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
